"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedItemLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const Avatar_1 = require("../../../util/Avatar/Avatar");
const utils_1 = require("../../../util/utils");
const FeedItemLogo = ({ userInfo }) => {
    const { fullName, avatar } = userInfo;
    let avatarName = '';
    let avatarType = Avatar_1.AvatarType.FORTO_AVATAR;
    if (avatar) {
        avatarName = avatar;
        avatarType = Avatar_1.AvatarType.THUMBNAIL_AVATAR;
    }
    else if (fullName) {
        avatarName = fullName;
        avatarType = Avatar_1.AvatarType.INITIALS_AVATAR;
    }
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Tooltip, { title: fullName, children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { avatar: avatarName, avatarType: avatarType, fullName: fullName, userType: (0, utils_1.isShipUserID)(userInfo.id) ? 'customer' : 'fortie', size: "large" }) }) }));
};
exports.FeedItemLogo = FeedItemLogo;
exports.default = exports.FeedItemLogo;
//# sourceMappingURL=FeedItemLogo.js.map